<section class="flex items-center justify-center h-full">
  <div class="max-w-[640px] w-full max-h-[80vh]">
    <h2 class="mb-5">
      {{ data.status ? 'List' : 'Unlist' }} your listing
    </h2>

    <ng-container *ngIf="error">
      <div class="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
        <h4 class="text-red-800 font-semibold m-0">{{ error.name }}</h4>
        <p class="text-red-600 m-0 mt-1">{{ error.description }}</p>
      </div>
    </ng-container>


    <div class="flex flex-col gap-6">
      <p class="m-0 leading-relaxed">
        <ng-template [ngIf]="data.status">
          You will start receiving new reservations and your listing will be visible in {{ data.listing.platform_key | platformLabel }} search results again.
        </ng-template>
        <ng-template [ngIf]="!data.status">
          You will stop receiving new reservations and your listing will be removed from {{ data.listing.platform_key | platformLabel }} search results.
        </ng-template>
      </p>

      <!-- Listing Card -->
      <sbnb-listing-card [listing]="data.listing"></sbnb-listing-card>

      <!-- Reasons -->
      <ng-container *ngIf="loading()">
        <div class="flex justify-center items-center py-8">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="(statusChangeResponse$ | async) as response">
        <div *ngIf="response.reasons.length > 0">
          <h4 class="mb-3">Please select a reason</h4>
          <div class="flex flex-col gap-3">
            <div *ngFor="let reason of response.reasons" class="flex flex-col gap-2">
              <sbnb-radio-card
                [selected]="selectedReason === reason.value"
                (click)="selectReason(reason.value, reason.has_conditional_input)"
                size="small"
              >
                <span>{{ reason.label }}</span>

                <div *ngIf="reason.has_conditional_input && selectedReason === reason.value" class="mt-4">
                  <mat-form-field class="w-full m-0 p-0">
                    <input
                      type="text"
                      [(ngModel)]="conditionalReason"
                      placeholder="Provide additional details..."
                      matInput
                    />
                  </mat-form-field>
                </div>
              </sbnb-radio-card>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="flex justify-end items-center gap-2 mt-4 mb-16">
        <sbnb-button type="secondary" (clicked)="onCancel()">
          Cancel
        </sbnb-button>
        <sbnb-button [disabled]="! allowed || ! canUpdate" [loading]="updating()" (clicked)="onConfirm()">
          {{ data.status ? 'List' : 'Unlist' }}
        </sbnb-button>
      </div>
    </div>
  </div>
</section>
